<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light navbar-custom">
    <div class="container-fluid">

        <ul class="navbar-nav me-auto mb-2 mb-lg-0"> 
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" 
                :id="swapid + 'navbarDropdown'" role="button" 
                    data-bs-toggle="dropdown" aria-expanded="false">Action 
            </a>
            <ul class="dropdown-menu" :aria-labelledby="swapid + 'navbarDropdown'">
              <slot name="menu"></slot>
            </ul>
          </li>
        </ul>

        <div v-if="margin=='3'" style="position:absolute;left:50%">
            {{title}} 
        </div>
        <div v-if="margin=='2'" style="position:absolute;left:40%">
            {{title}} 
        </div>
        <div v-if="margin=='1'" style="position:absolute;left:35%">
            {{title}} 
        </div>
        <div :title="'interval: ' + period" style="position:absolute;right:50px"> {{swapid}} </div>
    </div>
  </nav>
</template>

<style scoped>
.navbar-custom {
  height: 40px;
}
</style>

<script>
export default {
  name: 'SwapMenu',
  props: {
    period : Number,
    swapid : String,
    margin : String,
    title  : String
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>

